/* Quantity picker — pops the number when ± is clicked.
   Direction-aware (up on increase, down on decrease); only fires when the value
   actually changes, so clamped clicks at min/max stay silent.
   Uses document-level delegation: the theme re-renders/clones the quantity
   markup after load, which destroys per-element listeners — delegation is
   immune to that. */
(function () {
  'use strict';
  if (window.__qtyPopInit) return;
  window.__qtyPopInit = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.quantity--inner button');
    if (!btn) return;
    var input = btn.closest('.quantity--inner').querySelector('.quantity-input');
    if (!input) return;
    var before = input.value;
    /* quantity-set updates the value synchronously in its own click handler;
       a 0ms timeout runs after the current task, so the new value is in place
       regardless of listener order. */
    setTimeout(function () {
      if (input.value === before) return;
      var dir = parseFloat(input.value) > parseFloat(before) ? 'qty-pop-up' : 'qty-pop-down';
      input.classList.remove('qty-pop-up', 'qty-pop-down');
      void input.offsetWidth; /* restart animation on rapid clicks */
      input.classList.add(dir);
    }, 0);
  });

  document.addEventListener('animationend', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('quantity-input')) {
      t.classList.remove('qty-pop-up', 'qty-pop-down');
    }
  });
})();
